import { create } from "zustand";
import { INBOX_TAB_KEYS } from "../constants/Inbox.constants";

const initialState = {
  selectedContact: null,
  contactInfo: null,
  totalUnreadNotifications: 0,
  contactsListLoading: true,
  selectedInboxTab: INBOX_TAB_KEYS.DIRECT_MESSAGES,
  selectedInstagramPost: null,
  selectedInstagramPostId: null,
  isReplyClicked: null,
};

export const useInboxStore = create((set, get) => ({
  ...initialState,
  actions: {
    setContactsListLoading: (value) => set({ contactsListLoading: value }),
    setSelectedContact: (contact) => set({ selectedContact: contact }),
    getSelectedContact: () => get().selectedContact,
    setContactInfo: (data) => set({ contactInfo: data }),
    setTotalUnreadNotifications: (value) =>
      set({ totalUnreadNotifications: value }),
    reset: () => set({ ...initialState }),
  },
  setSelectedInboxTab: (val) => set({ selectedInboxTab: val }),
  setSelectedInstagramPost: (val) => set({ selectedInstagramPost: val }),
  setSelectedInstagramPostId: (val) => set({ selectedInstagramPostId: val }),
  setIsReplyClicked: (val) => set({ isReplyClicked: val }),
}));
